module.exports = "<div class=\"popup resource-substitution-popup\">\n  <h1 class=\"popup-subtitle\" data-localize=\"resource-substitution.microchip.title\"></h1>\n  <div class=\"popup-message\" data-localize=\"resource-substitution.description.1\"></div>\n  <div class=\"resource-button-1-container\"></div>\n  <div class=\"popup-message\" data-localize=\"resource-substitution.description.2\"></div>\n  <div class=\"resource-button-2-container\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/popup/resource-substitution.html
// module id = 826
// module chunks = 2